import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import App from "./components/App";
import "./index.css";
import { Provider } from "react-redux";
import store from "./app/store";
import ToggleDarkmode from "./utils/ToggleDarkmode";
const root = ReactDOM.createRoot(document.getElementById("root"));
const theme = createTheme({});
root.render(
  <Provider store={store}>
    <ToggleDarkmode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ToggleDarkmode>
  </Provider>
);
